import { render, staticRenderFns } from "./webhook-config.vue?vue&type=template&id=1ccd9ec6&scoped=true&"
import script from "./webhook-config.vue?vue&type=script&lang=js&"
export * from "./webhook-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccd9ec6",
  null
  
)

export default component.exports